/**
 * VueI18n don't play well with Props types (string), so we made an helper that enforce a string type
 * @see: https://github.com/kazupon/vue-i18n/issues/410
 */
const VueLang = {
  install(Vue) {
    Vue.prototype.$lang = function $lang( key:string, props?:Record<string, unknown>):string {
      return (this.$t(key, props) as string);
    };
  }
};

export {VueLang} ;


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-a7b31c50/vue-lang.tsx" });